/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  ResourceExecutionStatus,
  useEventActionResourceStateChangedSubscription,
} from "~/generated/graphql";

type Props = {
  eventId: string;
  isRunning: boolean;
  onResourceStateUpdate: (
    eventActionId: string,
    resourceStateId: string,
    status: ResourceExecutionStatus
  ) => void;
};

/**
 * Wrapper component to subscribe to resource state changes for all actions in an event.
 * Updates the resource state map for idempotent client-side counting.
 */
export function EventActionSubscriber({
  eventId,
  isRunning,
  onResourceStateUpdate,
}: Props) {
  useEventActionResourceStateChangedSubscription({
    variables: {
      eventId,
    },
    skip: !isRunning,
    onData: ({ data }) => {
      const change = data.data?.eventActionResourceStateChanged;
      if (!change) {
        return;
      }

      // Update the map with the new resource state
      onResourceStateUpdate(
        change.eventActionId,
        change.resourceStateId,
        change.status
      );
    },
  });

  return null;
}
